import * as React from "react";
import { IconProps } from "../types";

const BucketPaintOutlineIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        width="18"
        height="18"
        fill="none"
        viewBox="0 0 18 18"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
        {...props}
      >
        <path
          d="M14.375 16.75C15.411 16.75 16.25 15.898 16.25 14.847C16.25 13.402 15.199 12.784 14.375 11.75C13.551 12.784 12.5 13.402 12.5 14.847C12.5 15.898 13.339 16.75 14.375 16.75Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.81998 8.75H13.671"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.02299 0.748993L13.89 8.91699L8.00399 13.863C7.14999 14.58 5.87499 14.461 5.16899 13.598L2.20199 10.003C1.50299 9.14799 1.62899 7.88799 2.48499 7.18899L8.37499 2.37499"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
);

export default BucketPaintOutlineIcon;
